module.exports = __webpack_public_path__ + "img/finland-transport-accidents-male.004900cd.png";